import { z } from 'zod';
import { percentageSchema, priceSchema } from '../validation';

//* DO NOT change the names if there orders issued the Insurance name to avoid any validation problem ... later on we can turn this into a name
export const insuranceProviderNameSchema = z.enum(['Trade Union Co-operative Insurance', 'Other']);
export type InsuranceProviderName = z.infer<typeof insuranceProviderNameSchema>;

export const insuranceProviderSchema = z.object({
  /** name of the insurance company */
  name: insuranceProviderNameSchema,
  /** the total coverage amount on the shipment */
  itemsCoverageAmount: priceSchema,
  /** Rate is the cost of insurance represented as `percentage` of the goods value that we have to pay for the insurance provider.
   *
   * for example, if cost rate is `0.1%` and we have items total cost `200,000 SAR`.
   *
   * the cost amount = 0.1% * 200,000 SAR = `200 SAR`
   */
  rate: percentageSchema,
});
export type InsuranceProvider = z.infer<typeof insuranceProviderSchema>;
